var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('woot-custom-reports',{key:"custom-field-reports",attrs:{"type":"customField","getter-key":"customFields/getCustomFields","action-key":"customFields/get","download-button-label":_vm.$t('TEAM_REPORTS.DOWNLOAD_TEAM_REPORTS')}})}
var staticRenderFns = []

export { render, staticRenderFns }